import { render, staticRenderFns } from "./tuoiAcquisti.vue?vue&type=template&id=b757fbae&"
import script from "./tuoiAcquisti.vue.ts?vue&type=script&lang=ts&"
export * from "./tuoiAcquisti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports